import { themeVars } from '@libs/shared-ui-styles';

interface ShutterstockIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  primaryColor?: string;
  secondaryColor?: string;
}

export function ShutterstockIcon({
  primaryColor = 'currentColor',
  secondaryColor = themeVars.color.white,
  ...svgProps
}: ShutterstockIconProps) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <rect x="3" y="3" width="26" height="26" rx="1" fill={primaryColor} />
      <path
        d="M9 7H15V10H11C10.4477 10 10 10.4477 10 11L10 15H7V9C7 7.89543 7.89543 7 9 7Z"
        fill={secondaryColor}
      />
      <path
        d="M23 25H17V22L21 22C21.5523 22 22 21.5523 22 21L22 17H25V23C25 24.1046 24.1046 25 23 25Z"
        fill={secondaryColor}
      />
    </svg>
  );
}
